import Candidate from '@/api/http/candidate';

const state = {
  employeeInfo: null,
  schema: null,
  candidateForm: null,
};

const getters = {
  isFinished({ schema }) {
    if (!schema?.length) {
      return false;
    }

    return !schema.some(({ fields }) => {
      return fields.some(({ disabled }) => !disabled);
    });
  },
  startDate({ employeeInfo }) {
    return employeeInfo?.start_date;
  },
  dueDate({ candidateForm }) {
    return candidateForm?.due_date;
  },
  hasEmployeeInfo({ employeeInfo }) {
    return !!employeeInfo;
  },
  gDriveLink({ candidateForm }) {
    return candidateForm?.gdrive_link;
  },
};

const actions = {
  fetchCandidateForm: ({ commit }) => {
    return Candidate.getCandidateForm().then(({ data }) => {
      const { employee, sections, candidate_form: candidateForm } = data.result;

      commit('setEmployeeInfo', employee);
      commit('setSchema', sections);
      commit('setCandidateForm', candidateForm);
    });
  },
};

const mutations = {
  setEmployeeInfo(state, employeeInfo) {
    state.employeeInfo = employeeInfo;
  },
  setSchema(state, schema) {
    state.schema = schema;
  },
  setCandidateForm(state, candidateForm) {
    state.candidateForm = candidateForm;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
